import { Box, Typography } from '@mui/material'
import { plcSpeakers } from '../../data/plcContent'
import { sectionHeadingSx, MOBILE_MQ } from '../../theme/mobileLayout'

const SPEAKER_ROW_SX = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, 1fr)',
    md: 'repeat(3, 1fr)',
    xl: 'repeat(5, 288px)',
  },
  gap: '20px',
  justifyContent: { xl: 'flex-start' },
  // Laptop (lg): five fixed cards exceed viewport — scroll instead of overlap
  '@media (min-width: 1200px) and (max-width: 1535.95px)': {
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'thin',
    pb: 1,
  },
}

function SpeakerCard({ name, role, photo, photoTop = -20, photoLeft, photoWidth = 400 }) {
  return (
    <Box
      sx={{
        width: { xs: '100%', sm: 288 },
        maxWidth: 288,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: { xs: 300, sm: 340 },
          borderRadius: '20px',
          overflow: 'hidden',
          boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
          bgcolor: 'rgba(8,39,83,0.08)',
          position: 'relative',
        }}
      >
        <Box
          component="img"
          src={photo}
          alt={name}
          sx={{
            position: 'absolute',
            left: photoLeft !== undefined ? photoLeft : '50%',
            top: photoTop,
            transform: photoLeft !== undefined ? 'none' : 'translateX(-50%)',
            width: { xs: '100%', sm: photoWidth },
            maxWidth: { xs: '100%', sm: photoWidth },
            height: 533,
            maxWidth: 'none',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </Box>
      <Box sx={{ textAlign: { xs: 'left', sm: 'center' } }}>
        <Typography
          sx={{
            fontSize: { xs: 16, md: 22 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#000',
          }}
        >
          {name}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 16, md: 16 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: 'rgba(0,0,0,0.8)',
            mt: '4px',
          }}
        >
          {role}
        </Typography>
      </Box>
    </Box>
  )
}

export default function PlcSpeakersSection() {
  const row1 = plcSpeakers.slice(0, 5)
  const row2 = plcSpeakers.slice(5, 10)

  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 5, md: '80px' },
      }}
    >
      <Typography
        component="h2"
        sx={{
          ...sectionHeadingSx,
          [MOBILE_MQ]: { fontSize: 22 },
        }}
      >
        Our Esteemed Speakers
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 4, md: '40px' } }}>
        <Box sx={SPEAKER_ROW_SX}>
          {row1.map((speaker) => (
            <SpeakerCard key={speaker.name} {...speaker} />
          ))}
        </Box>
        <Box sx={SPEAKER_ROW_SX}>
          {row2.map((speaker) => (
            <SpeakerCard key={speaker.name} {...speaker} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}
